import type { CastWindow } from "./types";

const SDK_URL =
  "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
const SCRIPT_ID = "ottkit-cast-sdk";

let sdkPromise: Promise<boolean> | null = null;

/**
 * Грузит Cast Web Sender SDK один раз на вкладку (модульный синглтон): все
 * плееры на странице делят один и тот же промис и один и тот же `<script>`,
 * а window.cast.framework.CastContext сам по себе singleton SDK, так что
 * отдельный React-контекст для этого не нужен (как легасийный CastProvider
 * на корне приложения). Резолвится в false вне браузера и там, где SDK
 * недоступен (не Chrome/Chromium).
 */
export function loadCastSdk(): Promise<boolean> {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (sdkPromise) return sdkPromise;

  sdkPromise = new Promise<boolean>((resolve) => {
    (window as unknown as CastWindow).__onGCastApiAvailable = (isAvailable) => {
      if (isAvailable) {
        const win = window as unknown as CastWindow;
        // Один раз на страницу, а не на монтирование каждого Player:
        // CastContext сам singleton, повторный setOptions от второго
        // Player был бы просто избыточной, но безвредной перезаписью тех
        // же значений — держим здесь, рядом с загрузкой самого SDK.
        win.cast.framework.CastContext.getInstance().setOptions({
          receiverApplicationId:
            win.chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
          autoJoinPolicy: win.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
        });
      }
      resolve(Boolean(isAvailable));
    };

    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.src = SDK_URL;
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });

  return sdkPromise;
}
